import { quickStats } from "@/mocks/home";

export default function StatsStrip() {
  return (
    <section className="w-full border-y border-background-300/70 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-2 gap-4 px-4 py-6 md:grid-cols-4 md:px-6 md:py-7">
        {quickStats.map((stat) => (
          <div key={stat.label} className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className={`${stat.icon} text-xl`}></i>
            </span>
            <div className="flex flex-col">
              <span className="font-heading text-xl font-black text-foreground-950">{stat.value}</span>
              <span className="text-xs text-foreground-600">{stat.label}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}